'use client';

import classNames from 'classnames';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import styles from 'components/Heros/StandardHero/hero.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { StandardHeroProps } from 'components/Heros/StandardHero/config';
import type { FC } from 'react';

const learningCenterDomain = process.env.NEXT_PUBLIC_LEARNING_CENTER_SITE_DOMAIN || '';

const StandardHero: FC<StandardHeroProps> = ({ body, ctas, textColor, backgroundImage, foregroundImage }) => {
  const foregroundImageExists = Boolean(foregroundImage?.url);
  const isLightText = textColor === 'light';

  const classes = classNames(styles.background, {
    [styles.extraPadding]: !foregroundImageExists,
  });

  return (
    <section className={classes}>
      {backgroundImage?.url && (
        <Image
          fill
          className={styles.backgroundImage}
          url={backgroundImage?.url}
          alt="background image"
          sizes="100vw"
          priority
        />
      )}
      <div className={styles.container}>
        <div className={styles.text}>
          {body && <RichText className={styles.richText} content={body} light={isLightText} />}
          <div className={styles.ctas}>
            {isNonEmptyArray(ctas) &&
              ctas.map(cta => {
                const href = cta?.link === '/myMagMutual' ? learningCenterDomain : cta?.link;

                return (
                  <Button
                    key={`hero-buttons-${cta?.label}`}
                    url={href}
                    color={isLightText ? 'lightGray' : 'gray'}
                    textStyle="upper"
                    className={styles.cta}
                    label={cta?.label}
                    target="_self"
                  />
                );
              })}
          </div>
        </div>
        {foregroundImage?.url && (
          <div className={styles.media}>
            <div>
              <Image
                width={foregroundImage?.width || 630}
                height={foregroundImage?.height}
                className={styles.background}
                url={foregroundImage.url}
                alt="Foreground image"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default StandardHero;
